import { useTranslation } from "react-i18next";
import { useState } from "react";
import Questions from "./Questions";
import Modal from "react-bootstrap/Modal";
import Logo from "@components/Logo";
import { useDispatch } from "react-redux";
import ProductSaveModal from "./ProductSaveModal";
import ErrorPopup from "./ErrorPopup";
import validateProductStep from "../validations/validateProductStep";
import { useProductSlice } from "../helpers/helpers";
import { saveCurrentProduct } from "../helpers/submission";
import { resetStep } from "@services/redux/slices/stepSlice";
import CancelModal from "./CancelModal";
import { STEP_LEVEL_MAP } from "../helpers/mappings";
import { AiFillQuestionCircle } from "react-icons/ai";
import { BsFillBackspaceFill, BsQuestionCircle, BsXCircle } from "react-icons/bs";

const TopContent = ({ step }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const productType = localStorage.getItem("product");
  const productData = useProductSlice();

  // State
  const [showQuestions, setShowQuestions] = useState(false);
  const [showQuit, setShowQuit] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showSavedModal, setShowSavedModal] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [popupError, setPopupError] = useState("");

  // Save button logic
  const handleSave = async () => {
    setLoadingSave(true);
    setPopupError("");

    // Run validation first
    const validationError = validateProductStep(
      productType,
      productData,
      step,
      t
    );
    if (validationError) {
      setLoadingSave(false);
      setShowQuit(false);
      setPopupError(validationError);
      return; // stop before saving
    }

    try {
      await saveCurrentProduct(dispatch, productData, step);
      dispatch(resetStep());
      setLoadingSave(false);
      setShowQuit(false);
      setShowQuestions(false);
      setShowSavedModal(true);
    } catch (err) {
      setLoadingSave(false);
      setShowQuit(false);
      setPopupError(err?.message || t("something_went_wrong"));
    }
  };

  // get all save steps for this product type except the last step because it saves at "confirm"
  const saveSteps = Object.keys(STEP_LEVEL_MAP[productType] || {})
    .map(Number)
    .sort((a, b) => a - b)
    .slice(0, -1);

  return (
    <div className="bg-white w-100">
      {/* Questions modal */}
      <Questions
        t={t}
        step={step}
        show={showQuestions}
        handleClose={() => setShowQuestions(false)}
      />

      {/* Quit modal */}
      <Modal show={showQuit} onHide={() => setShowQuit(false)}>
        <Modal.Header closeButton>
          <Modal.Title className="text-dark">{t("save_and_exit")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="fs-6 text-dark py-3 fw-light">
            {t("quit_message")}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn-outline-blue p-3 px-4"
            onClick={() => setShowQuit(false)}
            disabled={loadingSave}
          >
            {t("cancel")}
          </button>
          <button
            className="btn-blue p-3 px-4 text-white d-flex align-items-center justify-content-center"
            onClick={handleSave}
            disabled={loadingSave}
          >
            {loadingSave && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
            )}
            {t("save")}
          </button>
        </Modal.Footer>
      </Modal>

      {/* Header */}
      <div className="container d-flex justify-content-between align-items-center  fs-6">
        <div>
        <button
          className="mx-2 mt-3 p-3 px-4 bg-white rounded-5 border text-dark top-button"
          onClick={() => setShowCancel(true)}
        >
          {t("cancel")}
        </button>
        {/* Save & Exit */}
        {saveSteps.includes(step) && (
          <button
            className="p-3 px-4 bg-white rounded-5 border text-dark top-button"
            onClick={() => setShowQuit(true)}
          >
            {t("save_and_exit")}
          </button>
        )}</div>
        {/* Your Questions */}
        {![0, 1, 6, 12, 17, 18].includes(step) && (
          <button
            className="mx-2  bg-white  text-dark "
            onClick={() => setShowQuestions(true)}

          >
            <BsQuestionCircle size={23} className="text-blue" />
          </button>
        )}





        {/* Saved modal */}
        {showSavedModal && (
          <ProductSaveModal
            open={showSavedModal}
            onClose={() => setShowSavedModal(false)}
            loading={loadingSave}
          />
        )}
        {showCancel && (
          <CancelModal
            open={showCancel}
            onClose={() => setShowCancel(false)}
            loading={loadingSave}
          />
        )}

        {/* Error popup */}
        <ErrorPopup
          open={!!popupError}
          onClose={() => setPopupError("")}
          message={popupError}
        />

      </div>
    </div>
  );
};

export default TopContent;
